
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Anders als manchmal behauptet, gibt es keine «Migränepersönlichkeit». Menschen
mit Migräne sind aber besonders empfindlich gegen plötzliche Änderungen im
Nervensystem. Vor allem schnelle und starke Wechsel im «Aktivierungszustand» –
also zum Beispiel zwischen Schlaf und Anspannung – provozieren die
Migräneattacken, weil die Nervenerregbarkeit gestört ist. Infolgedessen schütten
die Nervenzellen in bestimmten Hirnbereichen übermässig viele Botenstoffe aus,
was Schmerzsensoren aktiviert und zur Freisetzung von Entzündungsbotenstoffen
führt. Diese von den Nervenzellen ausgehende Entzündung erfasst auch die
Blutgefässe in den schmerzempfindlichen Hirnhäuten. Migräne wird heute also
nicht mehr als klassische psychosomatische Erkrankung betrachtet, obschon
psychische und soziale Faktoren eine Rolle spielen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;